import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=7038ba9b"
import script from "./MoneyInput.vue?vue&type=script&lang=js"
export * from "./MoneyInput.vue?vue&type=script&lang=js"
import style0 from "./MoneyInput.vue?vue&type=style&index=0&id=7038ba9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports